import { IconTrashX } from "@tabler/icons-react";
import Badge from "components/Badge";
import { observer } from "mobx-react-lite";
import { globalStore } from "store/GlobalStore";
import { epdSearchStore } from "features/EPDSearchModal/EPDSearchStore";

export default observer(function SelectedFilters() {
  const isEng = globalStore.currentLanguage === "en";

  const onRemoveFilter = (categoryId: string | number | undefined) => {
    const filteredItems = epdSearchStore.selectedFilters.filter(
      (rec) => rec.category.id !== categoryId
    );
    epdSearchStore.setSelectedFilters(filteredItems);
  };

  return (
    <div className="flex gap-4 mb-3 flex-wrap items-center">
      {epdSearchStore.selectedFilters.map((rec) => (
        <Badge
          closable
          key={rec.category.id}
          type="auto"
          className="!h-6 !mb-0 font-medium"
          onClose={() => onRemoveFilter(rec.category.id)}
        >
          <span className="font-bold">
            {isEng ? rec.category.name : rec.category.name_de}:
          </span>
          <span className="mx-1">
            {rec.items
              .map((item) => (isEng ? item.name : item.name_de))
              .join(", ")}
          </span>
        </Badge>
      ))}
      {epdSearchStore.selectedFilters.length > 0 && (
        <IconTrashX
          className="text-gray-700 cursor-pointer"
          size={20}
          stroke={2}
          onClick={() => epdSearchStore.setSelectedFilters([])}
        />
      )}
    </div>
  );
});
